import { render, staticRenderFns } from "./depositDetail.vue?vue&type=template&id=73af9520&scoped=true"
import script from "./depositDetail.vue?vue&type=script&lang=ts"
export * from "./depositDetail.vue?vue&type=script&lang=ts"
import style0 from "./depositDetail.vue?vue&type=style&index=0&id=73af9520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73af9520",
  null
  
)

export default component.exports